import { ICAMSKey, IAPIResult, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { Photos } from '../Photos/Photos';
import { ModalPrompts, PredefinedModalEnum } from '../Utility/ModalPrompts';

// LUT table 
export class ContactTypeModel { ListName: string; ContactRed: string; ContactTypeLUT: string; }
export type tasksCompletePanelCallback = (result: IAPIResult) => any;

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals',
}

export class Tasks_Complete {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openCompletePanel = (camsKey: ICAMSKey, showCancelBtns: Boolean, callback: tasksCompletePanelCallback): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL, viewData, submitURL, viewForm, viewModal, viewSubmit, viewCancel, viewClose;
        viewForm = "#taskCompleteForm";
        viewModal = "#taskCompleteModal";
        viewSubmit = "#taskCompleteSubmitBtn";
        viewCancel = "#taskCompleteCancelBtn";
        viewClose = "#taskCompleteCloseBtn";
        viewURL = window.G_SITEFOLDERNAME + "/Tasks/CompleteView";
        viewData = { taskID: camsKey.code };
        submitURL = "/Tasks/CompleteTask";

        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal(viewModal, ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader('#taskCompleteModal');

            // Get form validation
            Utilities.InitFormValidation($(viewForm));

            $(viewSubmit).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $(viewForm);
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($(viewModal + " .modal-content"));
                let formData = new FormData(<any>$(viewForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitURL,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Completed task!');
                                events.bus.publish(events.eventTaskUpdated(camsKey));
                                if (callback != null) { callback(result); }
                                else {
                                    events.bus.publish(events.eventResetAllPanels());
                                    events.bus.publish(events.eventRemoveAllMapInteractions());
                                    events.bus.publish(events.eventResetAllButtons(true));
                                    events.bus.publish(events.eventOpenMyTasksRecordListPanel());
                                }
                            }
                            else {
                                toastr.error('Failed to complete task!');
                                if (callback != null) callback(result);
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                            if (callback != null) callback({success: false});
                        }
                        finally {
                            Utilities.GetModal(viewModal, ModalAction.Hide);
                            Utilities.UnBlockUI($(viewModal + " .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            if (showCancelBtns == true) {
                $(viewCancel).on('click', function (evt) {
                    Utilities.GetModal(viewModal, ModalAction.Hide);
                    if (callback != null) callback({ success: false });
                });
                $(viewClose).on('click', function (evt) {
                    Utilities.GetModal(viewModal, ModalAction.Hide);
                    if (callback != null) callback({ success: false });
                });
            }
            else {
                $(viewCancel).hide();
                $(viewClose).hide();
            }
        });
    }

    public openCompleteGroupPanel = (camsKey: ICAMSKey): void => {
        const self = this;

        // Depending on the task or task group
        let viewURL, viewData, submitURL, viewForm, viewModal, viewSubmit, viewCancel;
        viewForm = "#taskGroupCompleteForm";
        viewModal = "#taskGroupCompleteModal";
        viewSubmit = "#taskGroupCompleteSubmitBtn";
        viewCancel = "#taskGroupCompleteCancelBtn";
        viewURL = "/Tasks/CompleteGroupView";
        viewData = { taskGroupID: camsKey.code };
        submitURL = "/Tasks/CompleteGroupTask";
        promptYesNoModal(); // If this is a group task, pop a yesno modal

        function promptYesNoModal() {

            ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.TaskCompleteAllInGroup }).then(r => {
                if (r.yes == true) {
                    loadForm();
                }
                else {
                }
            }).catch(e => { });

        }

        function loadForm() {
            Utilities.BlockUI();
            $('#placeholder-for-taskmodals').load(viewURL, viewData, function (response, status, xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
                Utilities.UnBlockUI();
                Utilities.GetModal(viewModal, ModalAction.Create);

                ($('#taskGroupCompleteTasksTable') as any).bootstrapTable();

                // Get form validation
                Utilities.InitFormValidation($(viewForm));

                $(viewSubmit).on('click', function (evt) {
                    evt.preventDefault();

                    // Validate
                    let form: any = $(viewForm);
                    if (Utilities.CheckFormValidation(form)==false) return;

                    Utilities.BlockUI($(viewModal + " .modal-content"));
                    let formData = new FormData(<any>$(viewForm)[0]);
                    $.ajax({
                        type: "POST",
                        processData: false,
                        contentType: false,
                        enctype: 'multipart/form-data',
                        url: submitURL,
                        data: formData,
                        success: function (result: IAPIResult) {
                            try {
                                if (result.success == true) {
                                    toastr.info('Completed task!');
                                    events.bus.publish(events.eventTaskUpdated(camsKey));
                                }
                                else {
                                    toastr.error('Failed to complete task!');
                                }
                            }
                            catch (err) {
                                console.log(err);
                                alert(err);
                            }
                            finally {
                                Utilities.GetModal(viewModal, ModalAction.Hide);
                                Utilities.UnBlockUI($(viewModal + " .modal-content"));
                            }
                        }
                    }).fail(function (xhr) {
                        if (xhr.status === 401) {//redirect to login in unauthorised
                            window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                        }
                    });
                });

                $(viewCancel).on('click', function (evt) {
                    Utilities.GetModal(viewModal, ModalAction.Hide);
                });
            });
        }

    }
}




